import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { StudioShell } from "./shell";
import StudioDashboard from "./StudioDashboard";
import StudioContent from "./StudioContent";
import StudioAnalytics from "./StudioAnalytics";
import StudioProfile from "./StudioProfile";

// Teacher marketplace = a YouTube-Studio-style creator dashboard. Lessons are
// authored in the separate Lessons area; here the teacher sees how their content
// is doing (Dashboard/Analytics), manages what's on the marketplace (Content),
// and edits their public channel identity (Profile). The active tab comes from
// the URL (`/teacher/marketplace/:tab`); each is its own panel so nothing is
// crammed onto one page.
const TABS = {
    dashboard: { title: "Dashboard", C: StudioDashboard },
    content: { title: "Content", C: StudioContent },
    analytics: { title: "Analytics", C: StudioAnalytics },
    profile: { title: "Profile", C: StudioProfile },
};

const TeacherMarketplace = () => {
    const navigate = useNavigate();
    const { tab } = useParams();
    const key = TABS[tab] ? tab : "dashboard";
    const { title, C } = TABS[key];
    return (
        <StudioShell active={key} navigate={navigate} title={title}>
            <C navigate={navigate} />
        </StudioShell>
    );
};

export default TeacherMarketplace;
